// Reference: https://www.notion.so/cuemath/Analytics-Upgrade-8fd2ddd953de47ccab959e96262235f4#186c459c257d4f6b93494189dc2514cd
export const CUEMATH_ERROR_CODES = {
    CM_MEDIA_CAMERA_1: 'CM_MEDIA_CAMERA_1',
    CM_MEDIA_CAMERA_2: 'CM_MEDIA_CAMERA_2',
    CM_MEDIA_CAMERA_3: 'CM_MEDIA_CAMERA_3',
    CM_MEDIA_CAMERA_4: 'CM_MEDIA_CAMERA_4',
    CM_MEDIA_CAMERA_5: 'CM_MEDIA_CAMERA_5',
    CM_MEDIA_CAMERA_6: 'CM_MEDIA_CAMERA_6',
    CM_MEDIA_CAMERA_7: 'CM_MEDIA_CAMERA_7',
    CM_MEDIA_CAMERA_8: 'CM_MEDIA_CAMERA_8',
    CM_MEDIA_CAMERA_9: 'CM_MEDIA_CAMERA_9',
    CM_MEDIA_CAMERA_10: 'CM_MEDIA_CAMERA_10',
    CM_MEDIA_CAMERA_11: 'CM_MEDIA_CAMERA_11',
    CM_MEDIA_CAMERA_12: 'CM_MEDIA_CAMERA_12',
    CM_MEDIA_CAMERA_13: 'CM_MEDIA_CAMERA_13',
    CM_MEDIA_CAMERA_14: 'CM_MEDIA_CAMERA_14',
    CM_MEDIA_CAMERA_15: 'CM_MEDIA_CAMERA_15',
    CM_MEDIA_MIC_1: 'CM_MEDIA_MIC_1',
    CM_MEDIA_MIC_2: 'CM_MEDIA_MIC_2',
    CM_MEDIA_MIC_3: 'CM_MEDIA_MIC_3',
    CM_MEDIA_MIC_4: 'CM_MEDIA_MIC_4',
    CM_MEDIA_MIC_5: 'CM_MEDIA_MIC_5',
    CM_MEDIA_MIC_6: 'CM_MEDIA_MIC_6',
    CM_MEDIA_MIC_7: 'CM_MEDIA_MIC_7',
    CM_MEDIA_MIC_8: 'CM_MEDIA_MIC_8',
    CM_MEDIA_MIC_9: 'CM_MEDIA_MIC_9',
    CM_MEDIA_MIC_10: 'CM_MEDIA_MIC_10',
    CM_MEDIA_MIC_11: 'CM_MEDIA_MIC_11',
    CM_MEDIA_MIC_12: 'CM_MEDIA_MIC_12',
    CM_MEDIA_MIC_13: 'CM_MEDIA_MIC_13',
    CM_MEDIA_MIC_14: 'CM_MEDIA_MIC_14',
    CM_MEDIA_MIC_15: 'CM_MEDIA_MIC_15',
    CM_MEDIA_1: 'CM_MEDIA_1',
    CM_MEDIA_2: 'CM_MEDIA_2',
    CM_MEDIA_3: 'CM_MEDIA_3',
    CM_MEDIA_4: 'CM_MEDIA_4',
    CM_MEDIA_5: 'CM_MEDIA_5',
    CM_MEDIA_6: 'CM_MEDIA_6',
    CM_MEDIA_7: 'CM_MEDIA_7',
    CM_MEDIA_8: 'CM_MEDIA_8',
    CM_MEDIA_9: 'CM_MEDIA_9',
    CM_MEDIA_10: 'CM_MEDIA_10',
    CM_MEDIA_11: 'CM_MEDIA_11',
    CM_MEDIA_12: 'CM_MEDIA_12',
    CM_MEDIA_13: 'CM_MEDIA_13',
    CM_MEDIA_14: 'CM_MEDIA_14',
    CM_MEDIA_15: 'CM_MEDIA_15',
    CM_MEDIA_SCREEN_1: 'CM_MEDIA_SCREEN_1',
};
export const SOURCE = {
    CAMERA: 'camera',
    MIC: 'microphone',
};
export const PUBLISH_RETRY_TIME = 15 * 1000;
export const SESSION_RETRY_TIME = 15 * 1000;
export const SUBSCRIBE_RETRY_TIME = 15 * 1000;
export const VIRTUAL_BACKGROUND_IMAGE = 'https://cuemath-intel.s3.ap-southeast-1.amazonaws.com/virtual-background/AC-background-new.png';
export const CAPTURE_IMAGE_ERR_MSG = {
    PEER_NOT_FOUND: 'Peer-Stream not found',
    STREAM_HANDLER_NOT_FOUND: 'Stream Handler not found.',
    IMAGE_NOT_GENERATE: 'Image was not generated',
};
//# sourceMappingURL=constant.js.map